export default __webpack_public_path__ + "static/media/Snd_Try9.868323eb.mp3";